var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("w-select", {
    staticClass: "mts",
    attrs: { items: _vm.statusList, label: _vm.$ct("status"), fancy: "" },
    model: {
      value: _vm.crm.StatusID,
      callback: function ($$v) {
        _vm.$set(_vm.crm, "StatusID", $$v)
      },
      expression: "crm.StatusID",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }